import _defineProperty from '../../node_modules/@babel/runtime/helpers/esm/defineProperty.js';
import React__default from 'react';
import PropTypes__default from 'prop-types';
import Typography from '@material-ui/core/Typography';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { BLOCKS, INLINES } from '@contentful/rich-text-types';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { retrieveContentfulImage } from './image.js';
import { LazyLoadImage } from 'react-lazy-load-image-component';

var useStyles = makeStyles(function (theme) {
  return {
    hyperlink: {
      color: theme.palette.text.primary,
      fontWeight: 500,
      cursor: "pointer",
      textDecoration: "underline",
      whiteSpace: "pre-wrap",
      wordWrap: "break-word",
      lineHeight: 0,
      "&:hover": {
        textDecoration: "underline"
      }
    },
    centeredButton: {
      display: "block",
      marginLeft: "auto",
      marginRight: "auto"
    },
    span: {
      margin: theme.spacing(0, "auto", 4, "auto")
    },
    mb4: {
      marginBottom: theme.spacing(4)
    },
    mb3: {
      marginBottom: theme.spacing(3)
    },
    mb2: {
      marginBottom: theme.spacing(2)
    },
    list: {
      margin: theme.spacing(0, 0, 1, 0)
    }
  };
});
var CustomRichText = function CustomRichText(_ref) {
  var _renderNode;
  var document = _ref.document,
    assetsMap = _ref.assetsMap,
    htmlComponentsMap = _ref.htmlComponentsMap,
    blogStyle = _ref.blogStyle;
  var classes = useStyles();

  // Custom style for blog rich text
  if (blogStyle) {
    var _document$content;
    document === null || document === void 0 || (_document$content = document.content) === null || _document$content === void 0 || _document$content.forEach(function (el, index) {
      if (el.nodeType === "paragraph" && document.content[index + 1] && (document.content[index + 1].nodeType === "paragraph" || document.content[index + 1].nodeType === "ordered_list" || document.content[index + 1].nodeType === "unordered_list")) {
        el.data.moreSpace = false;
      }
    });
  }
  var getHTMLComponent = function getHTMLComponent(id) {
    var comp = htmlComponentsMap.get(id);
    switch (comp === null || comp === void 0 ? void 0 : comp.type) {
      default:
        return undefined;
    }
  };
  var options = {
    renderMark: {},
    renderNode: (_renderNode = {}, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_renderNode, BLOCKS.HEADING_1, function (node, children) {
      return /*#__PURE__*/React__default.createElement(Typography, {
        variant: "h1",
        className: blogStyle && classes.mb4
      }, children);
    }), BLOCKS.HEADING_2, function (node, children) {
      return /*#__PURE__*/React__default.createElement(Typography, {
        variant: "h2",
        className: blogStyle && classes.mb4
      }, children);
    }), BLOCKS.HEADING_3, function (node, children) {
      return /*#__PURE__*/React__default.createElement(Typography, {
        variant: "h3",
        className: blogStyle && classes.mb4
      }, children);
    }), BLOCKS.HEADING_4, function (node, children) {
      return /*#__PURE__*/React__default.createElement(Typography, {
        variant: "h4",
        className: blogStyle && classes.mb4
      }, children);
    }), BLOCKS.HEADING_5, function (node, children) {
      return /*#__PURE__*/React__default.createElement(Typography, {
        variant: "h5",
        className: blogStyle && classes.mb4
      }, children);
    }), BLOCKS.HEADING_6, function (node, children) {
      return /*#__PURE__*/React__default.createElement(Typography, {
        variant: "h6",
        className: blogStyle && classes.mb4
      }, children);
    }), BLOCKS.UL_LIST, function (node, children) {
      return /*#__PURE__*/React__default.createElement("ul", {
        className: blogStyle && classes.list
      }, children);
    }), BLOCKS.OL_LIST, function (node, children) {
      return /*#__PURE__*/React__default.createElement("ol", {
        className: blogStyle && classes.list
      }, children);
    }), BLOCKS.PARAGRAPH, function (node, children) {
      return /*#__PURE__*/React__default.createElement(Typography, {
        variant: "body1",
        className: blogStyle && (node.data.moreSpace ? classes.mb4 : classes.mb3)
      }, children);
    }), BLOCKS.EMBEDDED_ASSET, function (node) {
      var comp = assetsMap.get(node.data.target.sys.id);
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(LazyLoadImage, {
        className: blogStyle && (comp !== null && comp !== void 0 && comp.description ? classes.mb2 : classes.mb4),
        src: retrieveContentfulImage(comp === null || comp === void 0 ? void 0 : comp.url),
        alt: "rich text image"
      }), blogStyle && (comp === null || comp === void 0 ? void 0 : comp.description) && /*#__PURE__*/React__default.createElement("span", {
        className: classes.span
      }, comp === null || comp === void 0 ? void 0 : comp.description));
    }), _defineProperty(_defineProperty(_defineProperty(_renderNode, BLOCKS.EMBEDDED_ENTRY, function (node) {
      return getHTMLComponent(node.data.target.sys.id);
    }), INLINES.EMBEDDED_ENTRY, function (node) {
      return getHTMLComponent(node.data.target.sys.id);
    }), INLINES.HYPERLINK, function (node, children) {
      return /*#__PURE__*/React__default.createElement("a", {
        href: node === null || node === void 0 ? void 0 : node.data.uri,
        className: classes.hyperlink
      }, children);
    }))
  };
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, document && documentToReactComponents(document, options));
};
CustomRichText.propTypes = {
  document: PropTypes__default.oneOfType([PropTypes__default.object, PropTypes__default.array]).isRequired,
  assetsMap: PropTypes__default.object,
  htmlComponentsMap: PropTypes__default.object,
  blogStyle: PropTypes__default.bool
};

export { CustomRichText as default };
//# sourceMappingURL=CustomRichText.js.map
